export default "__VITE_ASSET__BwaDr00D__"